export function filterSelectionList(baseArray, id) {
  if(baseArray.length === 0) {
    return baseArray
  }

  let cleanedArr = baseArray.filter(a=>a.id !== id)
  for(let idx in cleanedArr) {
    if(cleanedArr[idx].type == 'case-block') {
      cleanedArr[idx].filters = filterSelectionList(cleanedArr[idx].filters, id)
    }
  }
  return cleanedArr
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/filterSelectionList.js